"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YEARPICKER = exports.YEAR = exports.WEEKPICKER = exports.WEEK = exports.TIMEPICKER = exports.TIME = exports.QUARTERPICKER = exports.QUARTER = exports.MONTHPICKER = exports.MONTH = void 0;
const [WEEK, WEEKPICKER] = ['week', 'WeekPicker'];
exports.WEEKPICKER = WEEKPICKER;
exports.WEEK = WEEK;
const [MONTH, MONTHPICKER] = ['month', 'MonthPicker'];
exports.MONTHPICKER = MONTHPICKER;
exports.MONTH = MONTH;
const [YEAR, YEARPICKER] = ['year', 'YearPicker'];
exports.YEARPICKER = YEARPICKER;
exports.YEAR = YEAR;
const [QUARTER, QUARTERPICKER] = ['quarter', 'QuarterPicker'];
exports.QUARTERPICKER = QUARTERPICKER;
exports.QUARTER = QUARTER;
const [TIME, TIMEPICKER] = ['time', 'TimePicker'];
exports.TIMEPICKER = TIMEPICKER;
exports.TIME = TIME;